import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import ContactModel from 'donor-elf-web/models/contact';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import MergeContactsSection from 'donor-elf-web/components/add-something-modal/merge-contacts/section';
import FormUnderlineLabel from 'donor-elf-web/components/form/underline/label';
import FormUnderlineText from 'donor-elf-web/components/form/underline/text';
import CopyPasteButton from 'donor-elf-web/components/add-something-modal/merge-contacts/copy-paste-button';

interface ComponentArgs {
  changeset: any;
  contactToKeep: ContactModel;
  contactToMerge: ContactModel;
}

export default class AddSomethingModalMergeContactsMergeAddressPropertiesComponent extends Component<ComponentArgs> {

  get contactToKeepHasAddress() {
    return this.contactHasAddress(this.args.contactToKeep);
  }

  get contactToMergeHasAddress() {
    return this.contactHasAddress(this.args.contactToMerge);
  }

  contactHasAddress(contact: ContactModel) {
    return isPresent(
      [
        contact.address1,
        contact.address2,
        contact.city,
        contact.state,
        contact.zip,
        contact.country
      ].join('')
    );
  }

  copyAddressFrom = (contact: ContactModel) => {
    const { changeset } = this.args;
    changeset.set('address1', contact.address1);
    changeset.set('address2', contact.address2);
    changeset.set('city', contact.city);
    changeset.set('state', contact.state);
    changeset.set('zip', contact.zip);
    changeset.set('country', contact.country);
  }

  <template>
    <div ...attributes>
      <MergeContactsSection
        @header='Address'
      >
        <div>
          <div class='row'>
            <div class='col'>
              <FormUnderlineLabel @label='Street 1' class='mb-2'>
                <FormUnderlineText
                  @changeset={{@changeset}}
                  @property='address1'
                  class='w-100'
                />
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Street 2' class='mb-2'>
                <FormUnderlineText
                  @changeset={{@changeset}}
                  @property='address2'
                  class='w-100'
                />
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='City' class='mb-2'>
                <FormUnderlineText
                  @changeset={{@changeset}}
                  @property='city'
                  class='w-100'
                />
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='State' class='mb-2'>
                <FormUnderlineText
                  @changeset={{@changeset}}
                  @property='state'
                  class='w-100'
                />
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Zip' class='mb-2'>
                <FormUnderlineText
                  @changeset={{@changeset}}
                  @property='zip'
                  class='w-100'
                />
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Country' class='mb-2'>
                <FormUnderlineText
                  @changeset={{@changeset}}
                  @property='country'
                  class='w-100'
                />
              </FormUnderlineLabel>
            </div>
            <div class='col'>
              <FormUnderlineLabel @label='Contact to Keep'>
                {{#if this.contactToKeepHasAddress}}
                  <div class='d-flex'>
                    <div>
                      <CopyPasteButton
                        {{on 'click' (fn this.copyAddressFrom @contactToKeep)}}
                      />
                    </div>
                    <div>
                      <div>{{@contactToKeep.address1}}</div>
                      <div>{{@contactToKeep.address2}}</div>
                      <div>{{@contactToKeep.cityAndState}} {{@contactToKeep.zip}}</div>
                      <div>{{@contactToKeep.country}}</div>
                    </div>
                  </div>
                {{else}}
                  <div class='text-muted font-weight-light'>---</div>
                {{/if}}
              </FormUnderlineLabel>
              <FormUnderlineLabel @label='Contact to Merge' class='mt-3'>
                {{#if this.contactToMergeHasAddress}}
                  <div class='d-flex'>
                    <div>
                      <CopyPasteButton
                        {{on 'click' (fn this.copyAddressFrom @contactToMerge)}}
                      />
                    </div>
                    <div>
                      <div>{{@contactToMerge.address1}}</div>
                      <div>{{@contactToMerge.address2}}</div>
                      <div>{{@contactToMerge.cityAndState}} {{@contactToMerge.zip}}</div>
                      <div>{{@contactToMerge.country}}</div>
                    </div>
                  </div>
                {{else}}
                  <div class='text-muted font-weight-light'>---</div>
                {{/if}}
              </FormUnderlineLabel>
            </div>
          </div>
        </div>
      </MergeContactsSection>
    </div>
  </template>
}
